<template>
  <Container type="card-full">
    <div>
      <el-form :model="cos" label-position="left" label-width="80px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="平台名称">
             {{cos.cosname}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="search">
        <div class="search_box">
          <div class="searchItem">
            <div class="label">角色类型</div>
            <div class="field">
              `<el-select v-model="query.comtype" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">单位名称</div>
            <div class="field">
              <el-input v-model.trim="query.comfullname" clearable ></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="search_btn">
              <el-button @click="search">查询</el-button>
              <el-button @click="selectMember">添加成员</el-button>
              <el-button @click="delrow">删除成员</el-button>
            </div>
          </div>
        </div>
      </div>

      <vggrid ref="xGrid" :list="cosList" tableheight="500" flexname="" :cols="cols"
              :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
              @pagechange="pagechange">
      </vggrid>
      <el-dialog :close-on-click-modal="false" @close="closeDialog"  title="添加成员" :visible.sync="dialogVisible" width="60%">
        <div>
          <div class="search">
            <div class="search_box">
              <div class="searchItem">
                <div class="label"><span></span>角色类型</div>
                <div class="field">
                  `<el-select v-model="query.comtype" :clearable="true" placeholder="请选择">
                  <el-option
                    v-for="item in roles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </div>
              </div>
              <div class="searchItem">
                <div class="label">单位名称</div>
                <div class="field">
                  <el-input v-model.trim="query.comfullname" clearable ></el-input>
                </div>
              </div>
              <div class="searchItem">
                <div class="search_btn">
                  <el-button type='primary' @click="dialogsearch">查询</el-button>
                  <el-button type='primary' @click="submit">提交保存</el-button>
                </div>
              </div>
            </div>
          </div>
          <vxe-table
            border
            :data="alllist" ref="xGrid1">
            <vxe-table-column
              type="selection"
              width="55">
            </vxe-table-column>
            <vxe-table-column type="index" title="行号" width="60"></vxe-table-column>
            <vxe-table-column field="comfullname" title="单位名称"></vxe-table-column>
            <vxe-table-column field="comtypename" title="类型"></vxe-table-column>
            <!--<vxe-table-column field="username" title="申请加入人"></vxe-table-column>-->
            <!--<vxe-table-column field="cositemtime" title="加入时间"></vxe-table-column>-->
          </vxe-table>
        </div>
      </el-dialog>
      <!--<vxe-table-->
        <!--border-->
        <!--:data="list">-->
        <!--<vxe-table-column type="index" title="行号" width="60"></vxe-table-column>-->
        <!--<vxe-table-column field="comname" title="单位名称"></vxe-table-column>-->
        <!--<vxe-table-column field="username" title="申请加入人"></vxe-table-column>-->
        <!--<vxe-table-column field="cositemtime" title="加入时间"></vxe-table-column>-->
        <!--<vxe-table-column field="" title="操作">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button @click="delrow(scope.row)">删除</el-button>-->
          <!--</template>-->
        <!--</vxe-table-column>-->
      <!--</vxe-table>-->
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: "cosform",
    data () {
      return {
        dialogVisible: false,
        cos: this.$route.params.form,
        cositem: {},
        cosList: [],
        alllist: [],
        btnLoading: false,
        cvList: [],
        roles: [],
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '单位名称',calculExpr:''},
          { field: 'comtypename', fieldtype: 'C', title: '类型',calculExpr:''},
          { field: 'username', fieldtype: 'C', title: '申请加入人',calculExpr:''},
          { field: 'cositemtime', fieldtype: 'T',  title: '加入时间',calculExpr:'',formatter: ['toDateString', '']}
          ]
      }
    },
    activated () {
      this.init()
      this.getSysCodeList()
      this.getCosItemList()
    },
    created() {
    },
    mounted () {
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid},
    methods: {
      async getSysCodeList () {
        let res = await request({
          method: 'get',
          url: '/kfgl/syscode/getSysCodeList',
          params: {syscode: 'cositemcomtype'}
        })
        this.roles = res
      },
      async submit () {
        if (!this.$refs.xGrid1.selection.length) {
          this.$message.warning('请选择成员！')
          return
        }
        let data = await request({
          url: '/ywgl/cos/saveCosItems',
          method: "post",
          data: {cos: this.cos,cositems: this.$refs.xGrid1.selection}
        })
        if (data.issuccess===1) {
          this.query = {
            total: 0,
              limit: 20,
              offset: 0
          }
          await this.getCosItemList()
          this.$message.success('成员保存成功')
          this.dialogVisible = false
        } else {
          this.$message.error('成员保存失败')
        }
        // this.$refs.xGrid1.selection.forEach(v => {
        //   console.log(v)
        //   this.cosList.push(v)
        // })
        // this.cosList.length ? this.cosList.sort((t1, t2) => t1.dptname - t2.dptname) : this.dacitems

      },
      closeDialog () {
        this.query = {
          total: 0,
          limit: 20,
          offset: 0
        }
        this.getCosItemList()
        this.dialogVisible = false
      },
      async delrow () {
        let selects = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        if (!selects.length) {
          this.$message.warning('请选择要删除的成员！')
          return
        }
        let data = await request({
          url: '/ywgl/cos/delCosItems',
          method: "post",
          data: {cos: this.cos, cositems: selects}
        })
        if (data.issuccess===1) {
          await this.getCosItemList()
          this.$message.success('成员删除成功')
          this.dialogVisible = false
        } else {
          this.$message.error('成员删除失败')
        }
      },
      selectMember () {
        this.query = {
        }
        this.dialogVisible = true
        this.alllist = []
        // this.getCosList()
      },
      search () {
        this.query.offset = 0
        this.getCosItemList()
      },
      dialogsearch () {
        this.query.offset = 0
        // if (!this.query.comtype) {
        //   this.$message.warning('请选择角色类型查询！')
        //   return
        // }
        this.getCosList()
      },
      async init(){
        this.cos = this.$route.params.form
        this.list = []
      },
      async cellActived (row) {
      },
      async cellClick (row) {
        this.cositem = row.row
      },
      async getCosItemList () {
        this.query.cosid = this.cos.cosid
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/cos/getCosItemList',
          params: this.query
        })
        this.cosList = res.list
        this.query.total = res.count
        this.loading = false
      },
      async getCosList () {
        this.query.cosid = this.cos.cosid
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/cos/genCosItem',
          params: this.query
        })

        // this.query.total = res.count
        this.loading = false
        this.alllist = []
        if (this.cosList.length) {
          if (res.list.length) {
            res.list.forEach(v => {
              let i = this.cosList.findIndex(n => v.cositemcosid === n.cosid)
              if (i < 0) {
                v.cosid = v.cositemcosid
                this.alllist.push(v)
              }
            })
          }
        } else {
          this.alllist = res.list
        }
      },
      async save () {
        this.cos.userid = this.$store.getters.loginUser.userid
        let model = {
          cos: this.cos,
          cositems: this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        let data = await request({
          url: '/ywgl/cos/saveCosItems',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'cosIndex'})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getCosItemList()
      },
    }
  }
</script>

<style scoped>

</style>
